"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _minx = _interopRequireDefault(require("./minx"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  mixins: [_minx.default],
  data: function data() {
    return {
      title: '',
      type: null,
      dialogVisible: false,
      PlatformName: null,
      // 平台名称
      form: {
        platformCode: '',
        // 平台名称
        enable: 1,
        // 0:不启用 1 启用
        channelCode: '',
        // 渠道编码
        apiId: '',
        // 联盟id
        apiPromotionId: '',
        // 推广位id
        apiAppKey: '',
        // appKey
        apiAppSecret: '',
        // appSecret
        apiUrl: '',
        // 接口地址
        syncFlag: '',
        // 订单同步  0:不同步 1 同步
        syncStartTime: '',
        // 同步开始时间
        remark: '',
        // 备注
        ext: {
          feePercent: '',
          // 服务费预留比例
          sid: '',
          // sid
          signSecret: '',
          // 授权密钥
          mediaId: '',
          // 媒体位id
          tname: '',
          // 淘宝名称
          channelInviterCode: '',
          // 邀请码
          callBack: '' // 授权回调地址
        }
      },
      rules: {
        // enable: [{ required: true, message: '请选账号状态', trigger: 'change' }],
        // channelCode: [{ required: true, message: '请选选择渠道', trigger: 'change' }],
        // apiId: [{ required: true, message: '请输入联盟ID', trigger: 'blur' }],
        // 'ext.feePercent': [
        //   { required: true, message: '请输入预留比例', trigger: 'blur' },
        //   {
        //     type: 'number',
        //     min: 0,
        //     max: 100,
        //     message: '请输入0-100之间的数字'
        //   }
        // ]
      },
      showItemData: {
        'TB': ['enable', 'channelCode', 'apiId', 'feePercent', 'apiPromotionId', 'apiAppKey', 'apiAppSecret', 'sid', 'apiUrl', 'tname', 'channelInviterCode', 'callBack', 'syncFlag', 'syncStartTime', 'remark'],
        'DD': ['enable', 'channelCode', 'apiId', 'feePercent', 'apiPromotionId', 'apiAppKey', 'apiAppSecret', 'apiUrl', 'syncFlag', 'syncStartTime', 'remark'],
        'TXYX': ['enable', 'channelCode', 'apiId', 'feePercent', 'apiPromotionId', 'apiAppKey', 'apiAppSecret', 'apiUrl', 'syncFlag', 'syncStartTime', 'remark'],
        'QT': ['enable', 'channelCode', 'apiId', 'feePercent', 'apiPromotionId', 'apiAppKey', 'apiAppSecret', 'apiUrl', 'syncFlag', 'syncStartTime', 'remark'],
        'QF': ['enable', 'channelCode', 'apiId', 'feePercent', 'apiPromotionId', 'apiAppKey', 'apiAppSecret', 'apiUrl', 'syncFlag', 'syncStartTime', 'remark'],
        'MT': ['enable', 'channelCode', 'apiId', 'feePercent', 'apiPromotionId', 'apiAppKey', 'apiAppSecret', 'apiUrl', 'syncFlag', 'syncStartTime', 'remark'],
        'ELM': ['enable', 'channelCode', 'apiId', 'feePercent', 'apiPromotionId', 'apiAppKey', 'apiAppSecret', 'apiUrl', 'syncFlag', 'syncStartTime', 'remark'],
        'OT': ['enable', 'channelCode', 'apiId', 'feePercent', 'apiPromotionId', 'apiAppKey', 'apiAppSecret', 'apiUrl', 'syncFlag', 'syncStartTime', 'remark'],
        'KS': ['enable', 'channelCode', 'signSecret', 'apiId', 'feePercent', 'apiPromotionId', 'apiAppKey', 'apiAppSecret', 'apiUrl', 'syncFlag', 'syncStartTime', 'remark'],
        'PDD': ['enable', 'channelCode', 'mediaId', 'apiId', 'feePercent', 'apiPromotionId', 'apiAppKey', 'apiAppSecret', 'apiUrl', 'syncFlag', 'syncStartTime', 'remark'],
        'JD': ['enable', 'channelCode', 'apiId', 'feePercent', 'apiPromotionId', 'apiAppKey', 'apiAppSecret', 'apiUrl', 'syncFlag', 'syncStartTime', 'remark'],
        'WPH': ['enable', 'channelCode', 'apiId', 'feePercent', 'apiPromotionId', 'apiAppKey', 'apiAppSecret', 'apiUrl', 'syncFlag', 'syncStartTime', 'remark'],
        'DY': ['enable', 'channelCode', 'apiId', 'feePercent', 'apiPromotionId', 'apiAppKey', 'apiAppSecret', 'apiUrl', 'syncFlag', 'syncStartTime', 'remark']
      } // 显示的渠道数据
    };
  },
  methods: {
    onInit: function onInit() {
      var queryInt = {
        enable: 1,
        // 0:不启用 1 启用
        channelCode: '',
        // 渠道编码
        apiId: '',
        // 联盟id
        apiPromotionId: '',
        // 推广位id
        apiAppKey: '',
        // appKey
        apiAppSecret: '',
        // appSecret
        apiUrl: '',
        // 接口地址
        syncFlag: '',
        // 订单同步  0:不同步 1 同步
        syncStartTime: '',
        // 同步开始时间
        remark: '',
        // 备注
        ext: {
          feePercent: '',
          // 服务费预留比例
          sid: '',
          // sid
          signSecret: '',
          mediaId: '',
          // 媒体位id
          tname: '',
          // 淘宝名称
          channelInviterCode: '',
          // 邀请码
          callBack: '' // 授权回调地址
        }
      };
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), queryInt);
    }
  }
};